export default __webpack_public_path__ + "static/3-bf29e6c81f09f938dfd50bdb9ded92dc.jpeg";